import { createElement } from 'react';
import { Field } from 'redux-form';
import { prop, F } from 'ramda';
import PropTypes from 'prop-types';

const FormField = (
  { name, component, isStatic, value, disabled = F, ...other },
  { editing, formValues, localeMessage },
) =>
  editing && !isStatic
    ? createElement(Field, {
        name,
        component,
        editing,
        localeMessage,
        formValues,
        disabled: disabled(formValues),
        ...other,
      })
    : createElement(component, {
        name,
        localeMessage,
        formValues,
        editing: false,
        input: { value: value || prop(name, formValues) },
        ...other,
      });

FormField.propTypes = {
  name: PropTypes.string,
  isStatic: PropTypes.bool,
  value: PropTypes.any,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.element]),
  disabled: PropTypes.func,
};

FormField.contextTypes = {
  editing: PropTypes.bool,
  formValues: PropTypes.object,
  localeMessage: PropTypes.func,
};

export default FormField;
